import Vue from 'vue'
import ResourceService from './resource.service'
class TripService extends ResourceService {
  static get resource() {
    return 'trip'
  }

  static assignVehicle(slug, data) {
    const url = `${this.resource}/${slug}`

    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static unassignDriver(data) {
    const url = `${this.resource}/unassign-driver`

    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static unassignSecondaryDriver(data) {
    const url = `${this.resource}/unassign-secondary-driver`

    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static downloadTrips(params, slug = '') {
    const url = slug ? `${this.resource}/${slug}/download` : `${this.resource}/download`

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, {
          responseType: 'blob',
          params,
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static downloadTripsContracts(params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/download-for-contract`, {
          responseType: 'blob',
          params,
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static getTripRating(tripId) {
    const url = `rating`

    const params = {
      trip: tripId,
      select:
        'driverRating,driver.name,driver.arabicName,beneficiary.englishName,beneficiary.arabicName,beneficiaryComment,ratingReason',
    }

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default TripService
